import React from "react"
import { MdArrowUpward } from "react-icons/md"
import styles from "./sortIndicator.module.scss"

export interface SortIndicatorProps {
  /** Current sort direction for the host column. `null` = not sorted by this column. */
  direction: "asc" | "desc" | null
  /** Icon size in pixels. Defaults to 14. */
  size?: number
}

/** Renders the MdArrowUpward icon, rotated 180° on `desc`, with a CSS transition
 *  so asc → desc animates smoothly.
 *
 *  Visibility (hidden / hovered / active) is controlled by CSS classes that the
 *  parent <th> applies — import `sortIndicatorClasses` and spread them onto the th. */
const SortIndicator: React.FC<SortIndicatorProps> = ({ direction, size = 14 }) => {
  const isDesc = direction === "desc"
  return (
    <span
      className={styles.indicator}
      style={{ transform: isDesc ? "rotate(180deg)" : "rotate(0deg)" }}
      aria-hidden
    >
      <MdArrowUpward size={size} />
    </span>
  )
}

export default SortIndicator

/** CSS module class names re-exported so consumers (Table th, Hotels SortableHotelTh, …)
 *  can apply consistent hover/active styling without importing the SCSS file themselves. */
export const sortIndicatorClasses = {
  sortable: styles.sortable,
  active: styles.active,
  disabled: styles.disabled,
}
